<template>
   <seller />
</template>

<script>
import seller from './seller'

export default {
  name: 'test1',
  components: {
    seller
  },
  created() {

  },
  methods: {

  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// demo.vue?77f6dda3